import { useRouter } from "next/router";
import { Schema } from "components/Schema";
import createBreadcrumbsSchema from "utils/createBreadcrumbsSchema";
import getDomainFromLanguage from "utils/getDomainFromLanguage";
import type { LanguageCode } from "config/languages";
import type { BreadcrumbsSchemaProps } from "./BreadcrumbsSchema.d";

const BreadcrumbsSchema = ({ currentPositionName, parentPositionName }: BreadcrumbsSchemaProps) => {
  const {
    asPath: pagePath,
    query: { language },
  } = useRouter();
  if (!currentPositionName) return null;
  const domain = getDomainFromLanguage(language as LanguageCode);

  const currentUrl = `${domain}${pagePath}`;
  const firstElementUrl = `${domain}/${language}/`;
  const parentUrl = `${currentUrl.match(/(.*)\/.*\//)[1]}/`;

  const breadcrumbs = createBreadcrumbsSchema(
    firstElementUrl,
    currentPositionName,
    currentUrl,
    parentPositionName,
    parentUrl
  );

  return <Schema schema={breadcrumbs} />;
};

export default BreadcrumbsSchema;
